import script from "./base-bread.vue?vue&type=script&lang=js"
export * from "./base-bread.vue?vue&type=script&lang=js"

import "./base-bread.vue?vue&type=style&index=0&id=fb9ee4a0&lang=less"

export default script